import { FunctionGroupingArrayByKey } from "radium-omnibus";
import api from "../../../utils/useApi";

const FunctionAddBooleanToArrayObject = (array, cart) => {
  try {
    let newArray = array?.map((item) => {
      const findPrevious = cart?.find((row) => row._id === item._id);
      if (findPrevious) {
        return {
          ...item,
          isSelected: true,
        };
      } else {
        return {
          ...item,
          isSelected: false,
        };
      }
    });

    return newArray;
  } catch (error) {
    console.error("FunctionAddBooleanToArrayObject  :", error);
  }
};

const FunctionLoadAddOn = async (
  type,
  setAddOn,
  cart,
  setValue,
  setWater,
  setExtras,
  master_id,
  setTabMenu,
  setLoading,
  language,
  addons
) => {
  try {
    if (master_id) {
      const LoadDataFromPast = cart?.find(
        (item) => item.master_id === master_id && item.master
      );
      if (LoadDataFromPast?.master) {
        setValue(LoadDataFromPast);
      }

      const water = addons?.water;
      const thisAddons = addons?.addons?.filter((item) => {
        return item.master_id === master_id;
      });

      // const {
      //   data: { addons, water },
      // } = await api.get(`/addons?master_id=${master_id}&language=${language}`);

      const keys = FunctionGroupingArrayByKey(
        thisAddons,
        "type",
        [],
        ["ADDON", "PACKAGE", "EXTRA"] // sort
      );

      console.log("keys", keys);

      if (keys[0]?.value) {
        setAddOn(FunctionAddBooleanToArrayObject(keys[0].value, cart));
        setTabMenu(type === "My Dry" ? keys[0].value : keys[1].value);
      }

      if (water?.length > 0) {
        setWater(FunctionAddBooleanToArrayObject(water, cart));
      }

      if (keys[2]?.value) {
        setExtras(FunctionAddBooleanToArrayObject(keys[2].value, cart));
      }

      setLoading(false);
    } else {
      return;
    }
  } catch (error) {
    console.error("FunctionLoadAddOn  :", error);
  }
};
export default FunctionLoadAddOn;
